import { Injectable } from '@angular/core';
import { getEnvironment } from '../environment/environment';

@Injectable()
export class SettingsProvider {

  static api_url = '';

  static endpoints = {
    account: 'organizations/auth-customer/me',
  };

  constructor() {}

  static getAccount(): string{
    return this.endpoints.account;
  }

  static getUrl(url:string): string{
    this.api_url = getEnvironment().apiUrl;
    return this.api_url + url;
  }

  static getWalletUrl(url:string): string{
    this.api_url = getEnvironment().walletUrl;
    return this.api_url + url;
  }

}
